import { useCallback, useEffect, useState } from "react";
import AcademyAPI from "../services/academyService";

export const useAcademyCourseDetail = ({ courseId, enabled = true } = {}) => {
    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(Boolean(enabled));
    const [error, setError] = useState(null);

    const loadCourse = useCallback(async () => {
        if (!enabled || !courseId) {
            setLoading(false);
            setError(null);
            return;
        }
        setLoading(true);
        setError(null);

        try {
            const response = await AcademyAPI.getCourse(courseId);
            setCourse(response?.course || null);
        } catch (err) {
            setError(err?.message || "Error cargando curso");
            setCourse(null);
        } finally {
            setLoading(false);
        }
    }, [courseId, enabled]);

    useEffect(() => {
        loadCourse();
    }, [loadCourse]);

    return {
        course,
        loading,
        error,
        reload: loadCourse,
    };
};
